import { Link } from "react-router-dom";
import { BookOpen, ClipboardCheck, CreditCard, GraduationCap, ListChecks, Users, Video, Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, StatCard } from "@/components/dash/Common";
import { FullLoader } from "@/components/ProtectedRoute";
import { CsvButtons } from "@/pages/admin/Results";
import { useApi } from "@/hooks/useApi";
import { useAuth } from "@/context/AuthContext";
import { fmtDateTime, rupiah } from "@/lib/format";

export default function AdminOverview() {
  const { user } = useAuth();
  const { data, loading } = useApi("/admin/stats");
  if (loading || !data) return <FullLoader />;
  const isAdmin = user.role === "admin";
  return (
    <div data-testid="admin-overview-page">
      <PageHeader eyebrow={isAdmin ? "Admin" : "Pengajar"} title={`Selamat datang, ${user.name}`} description="Ringkasan aktivitas lembaga hari ini." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard dark label="Siswa aktif" value={data.active_students} hint={`dari ${data.students} siswa terdaftar`} icon={GraduationCap} testid="stat-active-students" />
        <StatCard label="Pengajar" value={data.teachers} icon={Users} testid="stat-teachers" />
        {isAdmin ? <StatCard label="Menunggu verifikasi" value={data.pending_payments} hint="pembayaran" icon={CreditCard} testid="stat-pending-payments" /> : <StatCard label="Kurikulum" value={data.courses} icon={BookOpen} />}
        {isAdmin ? <StatCard label="Pendapatan disetujui" value={rupiah(data.revenue)} icon={Wallet} testid="stat-revenue" /> : <StatCard label="Bank soal" value={data.questions} icon={ListChecks} />}
      </div>
      <div className="mt-6 grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-7 rounded-lg border border-slate-200 bg-white p-6" data-testid="admin-upcoming-classes">
          <div className="flex justify-between mb-4"><h2 className="font-display font-semibold">Kelas terdekat</h2><Link to="/admin/jadwal" className="text-xs text-amber-600 hover:underline">Kelola jadwal</Link></div>
          {data.upcoming.length === 0 ? <p className="text-sm text-slate-500">Belum ada jadwal.</p> : data.upcoming.map((c) => (
            <div key={c.id} className="py-3 border-b border-slate-100 last:border-0 flex gap-3"><Video className="h-4 w-4 mt-1 text-amber-500" /><div><p className="font-medium">{c.title}</p><p className="text-xs text-slate-500">{fmtDateTime(c.start_at)}</p></div></div>
          ))}
        </div>
        <div className="lg:col-span-5 rounded-lg border border-slate-200 bg-white p-6 space-y-5">
          <div><h2 className="font-display font-semibold">Rata-rata nilai ujian</h2><p className="font-display text-4xl font-extrabold mt-2" data-testid="admin-avg-score">{data.avg_score ?? "-"}</p></div>
          <div><p className="text-sm font-semibold mb-2">Unduh laporan CSV</p><CsvButtons /></div>
          {isAdmin && data.pending_payments > 0 && <Button asChild className="bg-amber-500 text-slate-900 hover:bg-amber-400 w-full" data-testid="go-verify-payments-button"><Link to="/admin/pembayaran"><ClipboardCheck className="h-4 w-4 mr-2" />Verifikasi {data.pending_payments} pembayaran</Link></Button>}
        </div>
      </div>
    </div>
  );
}
